import Effects from 'Effects';
import Tone from 'tone';
import {AudioParamPercentageValueParameter,
        AudioParamValueParameter} from 'parameters/AbstractAudioParamParameter.js';
import {saveParameterToJson, loadParameterFromJson} from 'parameters/parameterJsonFunctions.js';

class MultiCompressor extends Effects.Effect {
    constructor(name, effect, sequencerEngine) {
        super(name, effect, sequencerEngine);
        this.updateInitialValues();
    }

    dispose() {
        super.dispose();
    }

    setCompressors(compressors) {
        this.compressors = [];
        for (let name in compressors) {
            this.compressors.push(new CompressorPart(name, this.store, compressors[name]));
        }
    }

    getJson() {
        return {
            ...super.getJson(),
            compressors: this.compressors.map(x => x.getJson())
        };
    }

    fromJson(json, copy) {
        let bulk = super.fromJson(json, copy);

        for (let i in json.compressors) {
            let name = json.compressors[i].name;
            let compressor = this.getCompressor(name);
            compressor.fromJson(json.compressors[i], copy);
        }
        return bulk;
    }

    getCompressor(name) {
        return this.compressors.find(x => x.name === name);
    }
}

class CompressorPart {
    constructor(name, store, compressor) {
        this.name = name;
        this.store = store;
        this.compressorNode = compressor;
        this.parameters = [];

        this.thresholdParameter = new AudioParamValueParameter(
            'Threshold', this.compressorNode.threshold, {
                min: -80,
                max: 8,
                unit: '',
                defaultValue: 0,
                constantAutomationRate: true,
                automatable: false,
            });
        this.registerParameter(this.thresholdParameter);
        this.ratioParameter = new AudioParamValueParameter(
            'Ratio', this.compressorNode.ratio, {
                min: 1,
                max: 24,
                unit: '',
                defaultValue: 3, 
                constantAutomationRate: true,
            });
        this.registerParameter(this.ratioParameter);
        this.attackParameter = new AudioParamPercentageValueParameter(
            'Attack', this.compressorNode.attack,
            {
                constantAutomationRate: true,
            });
        this.registerParameter(this.attackParameter);
        this.releaseParameter = new AudioParamPercentageValueParameter(
            'Release', this.compressorNode.release,
            {
                constantAutomationRate: true
            });
        this.registerParameter(this.releaseParameter);
        this.releaseParameter.set(0.1);
        this.kneeParameter = new AudioParamValueParameter(
            'Knee', this.compressorNode.knee, {
                min: 0,
                max: 40,
                unit: 'db',
                defaultValue: 1,
                constantAutomationRate: true
            });
        this.registerParameter(this.kneeParameter);
    }

    registerParameter(parameter) {
        if (parameter !== undefined) {
            parameter.name = parameter.name;
            parameter.effectName = this.name;
            parameter.setStore(this.store);
            this.parameters.push(parameter);
        }
    }

    getJson() {
        let json = {
            name: this.name,
            threshold: this.thresholdParameter.get(),
            ratio: this.ratioParameter.get(),
            attack: this.attackParameter.get(),
            release: this.releaseParameter.get(),
        };

        
        json = saveParameterToJson(json, 'thresholdParameter', this.thresholdParameter);
        json = saveParameterToJson(json, 'ratioParameter', this.ratioParameter);
        json = saveParameterToJson(json, 'attackParameter', this.attackParameter);
        json = saveParameterToJson(json, 'releaseParameter', this.releaseParameter);
        return json;
    }

    fromJson(json, isCopy) {
        this.thresholdParameter.set(json.threshold);
        this.ratioParameter.set(json.ratio);
        this.attackParameter.set(json.attack);
        this.releaseParameter.set(json.release);

        loadParameterFromJson(json, 'thresholdParameter', this.thresholdParameter, isCopy);
        loadParameterFromJson(json, 'ratioParameter', this.ratioParameter, isCopy);
        loadParameterFromJson(json, 'attackParameter', this.attackParameter);
        loadParameterFromJson(json, 'releaseParameter', this.releaseParameter);
    }
}

export default MultiCompressor;
